import { z } from 'zod'

import { nanoidSchema, semverSchema, unixTimestamp } from '@/utility'
import { nanoid } from 'nanoid'
import { baseRegistrySchema } from '@/registry'

export const managedSchemaVersion = z.object({
  /** Version identifier */
  uid: nanoidSchema.default(nanoid),
  /** Semver version (0.0.1) for schema */
  version: semverSchema.default('0.0.1'),
  /** Metadata */
  createdAt: z.number().default(unixTimestamp),
  updatedAt: z.number().default(unixTimestamp),
})

export type ManagedSchemaVersion = z.infer<typeof managedSchemaVersion>

export const managedSchema = baseRegistrySchema.extend({
  /** Current version */
  activeVersionUid: nanoidSchema,
  /** All schema versions */
  versions: managedSchemaVersion.array(),
})

export type ManagedSchema = z.infer<typeof managedSchema>
